import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo  from 'vue-scrollto'
import common from './utils/common'
import VueAnalytics from 'vue-analytics'

Vue.use(VueScrollTo)

Vue.use(VueAnalytics, {
  id: 'UA-50550476-8',
  router
})
Vue.mixin(common)

Vue.config.productionTip = false

Vue.filter('addComma', function (value) {
  return Number(value).toLocaleString()
})

// Vue.use(VueLocalStorage)

new Vue({
  router,
  store,
  render: h => h(App),
  // localStorage: {
  //   viewed: {
  //     type: Array
  //   },
  // }
}).$mount('#app')
